/**
 * This class is auto generated by using the
 * "Dots.KLASIS.TsGenerator".
 * */
export const pages = {

    title: {
        classifications: `Klasifikācijas`,
        easyToRead: `Viegli lasīt`,
        lodResources: `Pamatresursu saraksts`,
        pageNotFound: `Lapa neeksistē`,
        searchResults: `Meklēšanas rezultāti`,
    },
}
